import {createRouter, createWebHistory} from 'vue-router'
import {useAuthStore} from "@/stores/authStore";
import { PERMISSIONS } from '@/constants/permissions';
import Pretrips from "@/views/powerpacks/Pretrips.vue";
import GensetInventory from "@/views/yardcheck/GensetInventory.vue";
import JobDetails from "@/views/billing/JobDetails.vue";
import Dashboard from "@/views/Dashboard.vue";
import Builds from "@/views/powerpacks/Builds.vue";
import BoSwaps from "@/views/powerpacks/BoSwaps.vue";
// Inventory Management
const InventoryDashboard = () => import("@/views/inventory/InventoryDashboard.vue");
const InventoryCategories = () => import("@/views/inventory/Categories.vue");
const InventorySuppliers = () => import("@/views/inventory/Suppliers.vue");
const InventoryItems = () => import("@/views/inventory/Items.vue");
const TransferInventory = () => import("@/views/inventory/TransferInventory.vue");
const AllTransfers = () => import("@/views/inventory/AllTransfers.vue");
const DeferredRequestsList = () => import("@/views/requests/DeferredRequestsList.vue");
const UnsentRequestsList = () => import("@/views/requests/UnsentRequestsList.vue");
const DomesticConsistParser = () => import("@/views/trains/DomesticConsistParser.vue");
const ConsistParser = () => import("@/views/trains/ConsistParser.vue");
const TrainMapView = () => import("@/views/trains/TrainMapView.vue");
// const TrainSearchView = () => import("@/views/trains/TrainSearchView.vue");
// const YardCheckUnitSearch = () => import("@/views/yardcheck/YardCheckUnitSearch.vue");
const UnattachedWaybills = () => import("@/views/waybill/UnattachedWaybills.vue");
// import NewTrain from "@/components/trains/NewTrain.vue";
// import TrainEtaUpdate from "@/components/trains/TrainEtaUpdate.vue";
// import TrainConsist from "@/components/trains/TrainConsist.vue";
// import SearchCN from "@/components/u
// nit-lookup/SearchCN.vue";
// import WaybillSearch from "@/components/waybill/WaybillSearch.vue";
// import UnitCardContainer from "@/components/UnitCardContainer.vue";
const loginPage = () => import('../views/auth/LoginViewWithPasskey.vue');
const cnUnitQuery = () => import("../views/CnUnitQuery.vue");
const ConsistPage = () => import('../views/trains/ConsistPage.vue');
const MainLayout = () => import("../layout/MainLayout.vue");
const NotFoundPage = () => import('../views/errors/NotFoundPage.vue');
const RequestList = () => import('../views/requests/CurrentRequestList.vue');
const RequestDetail = () => import('../views/requests/RequestDetail.vue');
const RequestGroupList = () => import('../views/requests/RequestGroupList.vue');
const RequestGroupDetail = () => import('../views/requests/RequestGroupDetail.vue');
const RequestGroupDebug = () => import('../views/requests/RequestGroupDebug.vue');
const FuelLedger = () => import('../views/fuel/FuelLedger.vue');
const FuelIntoTrucksLog = () => import('../views/fuel/FuelIntoTrucksLog.vue');
const FuelDiscrepancyReport = () => import('../views/fuel/FuelDiscrepancyReport.vue');
const FuelMeterCalibration = () => import('../views/fuel/FuelMeterCalibration.vue');
const FuelPerformanceDashboard = () => import('../views/fuel/FuelPerformanceDashboard.vue');
const AdminPanel = () => import('../views/admin/AdminPanel.vue');
const ApiAnalytics = () => import('../views/admin/ApiAnalytics.vue');
const StatisticsPage = () => import('../views/reports/StatisticsPage.vue');
const clipDashboard = () => import("../views/clipons/ClipDashboard.vue");
const ActivityFeedView = () => import('../views/activity/ActivityFeedView.vue');
const TestRoleManagement = () => import("../components/test/TestRoleManagement.vue")
const pretripDetails = () => import("../views/clipons/PretripDetails.vue")
const clipInstallDetails = () => import("../views/clipons/ClipInstallDetails.vue")
const clipRemovalDetails = () => import("../views/clipons/ClipRemovalDetails.vue")
const Calendar = () => import('../views/Calendar.vue');
const TrainLineupDataView = () => import('../components/TrainLineupDataView.vue');
const AddBulkElectrics = () => import('../views/trains/AddBulkElectrics.vue');
const MySubscriptions = () => import('../views/user/MySubscriptions.vue');
const FieldTrainCheck = () => import('../views/trains/FieldTrainCheck.vue');
const TrainTime = () => import("../views/billing/TrainTime.vue");
const TrainHistory = () => import('../views/trains/History.vue');
const PasteableLineup = () => import('../views/trains/PasteableLineup.vue');
const YardCheckDashboard = () => import('../views/yardcheck/YardCheckDashboard.vue');
const PerformYardCheck = () => import('../views/yardcheck/PerformYardCheck.vue');
const ViewYardCheck = () => import('../views/yardcheck/ViewYardCheck.vue');
const RequestPrintConfiguration = () => import('../views/requests/RequestPrintConfiguration.vue');
const JobsView = () => import('../views/billing/JobsView.vue');
const WhosIn = () => import('../views/staffing/WhosIn.vue');
const ShiftUtilization = () => import('../views/staffing/ShiftUtilization.vue');
const StatusSummary = () => import('../views/fleet/StatusSummary.vue');
const SpeedAlerts = () => import('../views/fleet/SpeedAlerts.vue');
const MyTimes = () => import('../views/user/MyTimes.vue')
const UserSettings = () => import('../views/user/UserSettings.vue')
const UserProfile = () => import('../views/user/UserProfile.vue')
const Forbidden = () => import('../views/errors/Forbidden.vue');
const RequestHistoryList = () => import('../views/requests/RequestHistoryList.vue');
// Invoicing
const InvoiceList = () => import('../views/invoices/InvoiceList.vue');
const InvoiceCreate = () => import('../views/invoices/InvoiceCreate.vue');
const InvoiceDetail = () => import('../views/invoices/InvoiceDetail.vue');
// Import test harness
const FieldUnitCardTestHarness = () => import('../tests/views/TestHarness.vue');
// Import the new Bill Job View
const BillJobView = () => import('../views/billing/BillJobView.vue');
// Import the TrainSplitBillView
const TrainSplitBillView = () => import('../views/billing/TrainSplitBillView.vue');
const InvoiceReport = () => import('../views/reports/InvoiceReport.vue');
const InventoryReport = () => import('@/views/reports/InventoryReport.vue');
const WorkerTimeReport = () => import('../views/reports/WorkerTimeReport.vue');
const GlobalSearch = () => import('@/views/GlobalSearch.vue');
const WaybillDetail = () => import('../views/WaybillDetail.vue');

// Diagnostic Tool
const DiagnosticTool = () => import('../views/DiagnosticTool.vue');

// Admin Debug
const AdminDebug = () => import('../views/admin/AdminDebug.vue');

// Work Order routes
const WorkOrderList = () => import('../views/work-orders/WorkOrderList.vue');
const WorkOrderForm = () => import('../views/work-orders/WorkOrderForm.vue');
const WorkOrderDetail = () => import('../views/work-orders/WorkOrderDetail.vue');

// Undermount Gensets routes
const UndermountGensetsPage = () => import('../views/undermount-gensets/UndermountGensetsPage.vue');
const UndermountGensetDetail = () => import('../views/undermount-gensets/UndermountGensetDetail.vue');

// Train and Yard Check Results
const TrainCheckResults = () => import('../views/trains/TrainCheckResults.vue');
const TrainLocationHistory = () => import('../views/trains/LocationHistory.vue');
const YardCheckResults = () => import('../views/yardcheck/YardCheckResults.vue');

// Contacts
const ContactsDirectory = () => import('../views/contacts/ContactsDirectory.vue');

// Safety routes
const TrackProtectionDashboard = () => import('../views/safety/TrackProtectionDashboard.vue');

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            component: MainLayout,
            meta: {requiresAuth: true},
            children: [
                {path: '', component: TrainLineupDataView, meta: { requiredPermissions: [PERMISSIONS.TRAINS_READ] }},
                {path: 'trains', name: 'TrainLineup',component: TrainLineupDataView, meta: { requiredPermissions: [PERMISSIONS.TRAINS_READ] }},
                {path: 'trains/history', component: TrainHistory, meta: { requiredPermissions: [PERMISSIONS.TRAINS_READ] }},
                {path: 'calendar', name: 'Calendar', component: Calendar, meta: { requiredPermissions: [PERMISSIONS.TRAINS_READ] }},
                // Disabled train search page
                // {path: 'trains/search', name: 'TrainSearch', component: TrainSearchView},
                {path: 'trains/:trainid', component: ConsistPage, props: true, meta: { requiredPermissions: [PERMISSIONS.TRAINS_READ] }},
                {path: 'trains/:trainid/time', component: TrainTime, props: true, meta: { requiredPermissions: [PERMISSIONS.TRAINS_READ] }},
                {path: 'trains/:trainid/check-results', name: 'TrainCheckResults', component: TrainCheckResults, props: true, meta: { pageTitle: 'Train Check Results', requiresAuth: true }},
                {path: 'trains/:trainid/location-history', name: 'TrainLocationHistory', component: TrainLocationHistory, props: true, meta: { pageTitle: 'Train Location History', requiresAuth: true, requiredPermissions: [PERMISSIONS.TRAINS_READ] }},
                {path: 'trains/:trainid/consist-parser', name: 'ConsistParser', component: ConsistParser, props: true, meta: { requiredPermissions: [PERMISSIONS.TRAINS_UPDATE] }},
                {path: 'trains/:trainid/domestic-consist-parser', name: 'DomesticConsistParser', component: DomesticConsistParser, props: true, meta: { requiredPermissions: [PERMISSIONS.TRAINS_UPDATE] }},
                {path: 'unitquery', name: 'unitQueryPage', component: cnUnitQuery},
                {path: 'global-search', name: 'GlobalSearch', component: GlobalSearch, meta: { pageTitle: 'Global Equipment Search', requiresAuth: true }},
                {path: 'track-protection', name: 'TrackProtectionDashboard', component: TrackProtectionDashboard, meta: { pageTitle: 'Track Protection Monitor', requiresAuth: true, requiredPermissions: [PERMISSIONS.DISPATCH_VIEW] }},
                {path: 'requests', component: RequestList, meta: { requiredPermissions: [PERMISSIONS.REQUESTS_READ] }},
                {path: 'requests/:id', component: RequestDetail, props: true, meta: { requiredPermissions: [PERMISSIONS.REQUESTS_READ] }},
                // Contacts Directory
                {
                  path: 'contacts',
                  name: 'ContactsDirectory',
                  component: ContactsDirectory,
                  meta: {
                    pageTitle: 'Contacts Directory',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.REQUESTS_READ]
                  }
                },
                {path: 'requests/history', component: RequestHistoryList},
                {path: 'requests/deferred-info', component: DeferredRequestsList},
                {path: 'requests/unsent', component: UnsentRequestsList},
                {path: 'requests/print-setup', name: 'requestPrintConfiguration', component: RequestPrintConfiguration},
                {path: 'fuel', name: 'FuelLedger', component: FuelLedger, meta: { requiredPermissions: [PERMISSIONS.FUEL_READ] }},
                {path: 'fuel/into-trucks', name: 'FuelIntoTrucksLog', component: FuelIntoTrucksLog, meta: { requiredPermissions: [PERMISSIONS.FUEL_READ] }},
                {path: 'fuel/discrepancy-report', name: 'FuelDiscrepancyReport', component: FuelDiscrepancyReport, meta: { requiredPermissions: [PERMISSIONS.FUEL_APPROVE, PERMISSIONS.ADMIN_MANAGE] }},
                {path: 'fuel/meter-calibration', name: 'FuelMeterCalibration', component: FuelMeterCalibration, meta: { requiresAuth: true, requiredPermissions: [PERMISSIONS.ADMIN_ACCESS, PERMISSIONS.REPORTS_VIEW] }},
                {path: 'fuel/performance-dashboard', name: 'FuelPerformanceDashboard', component: FuelPerformanceDashboard, meta: { requiresAuth: true, requiredPermissions: [PERMISSIONS.ADMIN_ACCESS, PERMISSIONS.REPORTS_VIEW] }},
                {path: 'admin', name: 'adminPanel', component: AdminPanel, meta: { requiresAuth: true, requiredPermissions: [PERMISSIONS.ADMIN_ACCESS] }},
                {path: 'admin/api-analytics', name: 'apiAnalytics', component: ApiAnalytics, meta: { requiresAuth: true, requiredPermissions: [PERMISSIONS.ADMIN_ACCESS] }},
                {path: 'admin/debug', name: 'adminDebug', component: AdminDebug, meta: { requiresAuth: true }},
                {path: 'admin/test-roles', name: 'testRoles', component: TestRoleManagement, meta: { requiresAuth: true }},
                {path: 'admin/shifts', name: 'adminShifts', component: () => import('../components/admin/ShiftManagement.vue'), meta: { requiresAuth: true, requiredPermissions: [PERMISSIONS.ADMIN_ACCESS] }},
                {
                  path: 'diagnostics',
                  name: 'DiagnosticTool',
                  component: DiagnosticTool,
                  meta: {
                    pageTitle: 'Issue Diagnostic Tool',
                    requiresAuth: true,
                  }
                },
                {path: '/reports/statistics', name: 'statisticsReport', component: StatisticsPage},
                {
                  path: '/reports/worker-time',
                  name: 'WorkerTimeReport',
                  component: WorkerTimeReport,
                  meta: {
                    pageTitle: 'Worker Time Report',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.TIME_READ, PERMISSIONS.REPORTS_VIEW]
                  },
                },
                {path: '/clipons', name: 'cliponDashboard', component: clipDashboard, meta: { requiredPermissions: [PERMISSIONS.CLIP_ONS_READ] }},
                {path: '/clipons/pretrip/:id', name: 'pretripDetails', component: pretripDetails, props: true, meta: { requiredPermissions: [PERMISSIONS.CLIP_ONS_READ] }},
                {path: '/clipons/install/:eventId', name: 'ClipInstallDetails', component: clipInstallDetails, props: true, meta: { requiredPermissions: [PERMISSIONS.CLIP_ONS_UPDATE] }},
                {path: '/clipons/removal/:eventId', name: 'ClipRemovalDetails', component: clipRemovalDetails, props: true, meta: { requiredPermissions: [PERMISSIONS.CLIP_ONS_UPDATE] }},
                {path: '/calendar', name: 'calendarComponent', component: Calendar},
                {path: 'trains/:trainid/bulkelectrics', name: 'BulkElectrics', component: AddBulkElectrics},
                // {path: 'trains/:trainid/bulkelectrics2', name: 'BulkElectrics2', component: AddBulkElectrics2},
                {path: 'user/subscriptions', name: 'UserSubscriptions', component: MySubscriptions},
                {path: 'user/times', name: 'MyTimes', component: MyTimes},
                {path: 'user/settings', name: 'UserSettings', component: UserSettings},
                {path: 'user/profile', name: 'UserProfile', component: UserProfile, meta: { requiresAuth: true }},
                {path: 'billing', redirect: '/billing/jobs'},
                {path: 'billing/jobs', name: 'JobView', component: JobsView},
                {path: 'billing/jobs/:jobId', name: 'JobDetails', component: JobDetails, props: true},
                {path: 'billing/jobs/:jobId/bill', name: 'BillJob', component: BillJobView, props: true},
                {path: 'billing/trains/:trainid/split-bill', name: 'TrainSplitBill', component: TrainSplitBillView, props: true},
                {path: 'trains/lineup/pasteable', name: 'PasteableLineup', component: PasteableLineup},
                // Train map
                {path: 'trains/map', name: 'TrainMap', component: TrainMapView, meta: { pageTitle: 'Train Location Map', requiresAuth: true }},
                {path: 'yard-check', name: 'YardCheckDashboard', component: YardCheckDashboard, meta: { requiredPermissions: [PERMISSIONS.YARD_CHECK_READ] }},
                // Disabled yard check unit search
                // {path: 'yard-check/search-units', name: 'YardCheckUnitSearch', component: YardCheckUnitSearch},
                {path: 'yard-check/:yardCheckId/perform', name: 'PerformYardCheck', component: PerformYardCheck, props: true, meta: { requiredPermissions: [PERMISSIONS.YARD_CHECK_CREATE, PERMISSIONS.YARD_CHECK_UPDATE] }},
                {path: 'yard-check/:yardcheckid/results', name: 'YardCheckResults', component: YardCheckResults, props: true, meta: { pageTitle: 'Yard Check Results', requiresAuth: true, requiredPermissions: [PERMISSIONS.YARD_CHECK_READ] }},
                {path: 'yard-check/:yardCheckId', name: 'ViewYardCheck', component: ViewYardCheck, props: true, meta: { requiredPermissions: [PERMISSIONS.YARD_CHECK_READ] }},
                {path: 'staffing/whos-in', name: 'WhosIn', component: WhosIn},
                {
                  path: 'staffing/shift-utilization',
                  name: 'ShiftUtilization',
                  component: ShiftUtilization,
                  meta: {
                    pageTitle: 'Shift Utilization',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.STAFFING_READ_SHIFT_UTILIZATION]
                  }
                },
                {path: 'forbidden', name: 'Forbidden', component: Forbidden},
                {path: 'fleet/summary', name: 'FleetSummary', component: StatusSummary},
                {path: 'fleet/speed-alerts', name: 'SpeedAlerts', component: SpeedAlerts, meta: { pageTitle: 'Speed Alerts', requiresAuth: true, requiredPermissions: [PERMISSIONS.ADMIN_ACCESS, PERMISSIONS.REPORTS_VIEW] }},
                {path: 'powerpack/pretrips', name: 'PowerpackPretrips', component: Pretrips},
                {path: 'powerpack/inventory', name: 'PowerpackGensetInventory', component: GensetInventory, props: true},
                {path: 'powerpack/builds', name: 'GensetBuildsList', component: Builds, meta: { requiredPermissions: [PERMISSIONS.POWER_PACKS_READ] }},
                {path: 'powerpack/bo-swaps', name: 'PowerpackBoSwaps', component: BoSwaps},
                // Undermount Gensets routes
                {
                  path: 'undermount-gensets',
                  name: 'UndermountGensets',
                  component: UndermountGensetsPage,
                  meta: {
                    pageTitle: 'Undermount Gensets',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.UNDERMOUNTS_READ]
                  }
                },
                {
                  path: 'undermount-gensets/:gensetNumber',
                  name: 'UndermountGensetDetail',
                  component: UndermountGensetDetail,
                  props: true,
                  meta: {
                    pageTitle: 'Genset Details',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.UNDERMOUNTS_READ]
                  }
                },
                {path: 'waybills/unattached', name: 'UnattachedWaybills', component: UnattachedWaybills},
                // {path: 'consist-parser', name: 'ConsistParser', component: ConsistParser},

                {path: 'yard-check/genset-inventory', name: 'YardCheckGensetInventory', component: GensetInventory, props: true},
                // {path: '/dashboard', name: 'Dashboard', component: Dashboard},



                {path: 'request-groups', component: RequestGroupList},
                {path: 'request-groups/:id', component: RequestGroupDetail, props: true},
                {path: 'request-groups-debug', component: RequestGroupDebug},
                // Invoice routes
                {
                  path: 'invoices',
                  name: 'InvoiceList',
                  component: InvoiceList,
                  meta: {
                    pageTitle: 'Invoices',
                    requiresAuth: true,
                  },
                },
                {
                  path: 'invoices/create',
                  name: 'InvoiceCreate',
                  component: InvoiceCreate,
                  meta: {
                    pageTitle: 'Create New Invoice',
                    requiredPermissions: ['invoices:create'],
                    requiresAuth: true,
                  },
                },
                {
                  path: 'invoices/:id',
                  name: 'InvoiceDetail',
                  component: InvoiceDetail,
                  meta: {
                    pageTitle: 'Invoice Details',
                    requiresAuth: true,
                  },
                },
                {
                  path: 'invoices/:id/edit',
                  name: 'InvoiceEdit',
                  component: InvoiceCreate,
                  props: route => ({ isEditing: true, invoiceId: parseInt(route.params.id as string) }),
                  meta: {
                    pageTitle: 'Edit Invoice',
                    requiredPermissions: ['invoices:update'],
                    requiresAuth: true,
                  },
                },
                // Work Order routes
                {
                  path: 'work-orders',
                  name: 'WorkOrderList',
                  component: WorkOrderList,
                  meta: {
                    pageTitle: 'Work Orders',
                    requiresAuth: true,
                  },
                },
                {
                  path: 'work-orders/create',
                  name: 'WorkOrderCreate',
                  component: WorkOrderForm,
                  meta: {
                    pageTitle: 'Create Work Order',
                    requiresAuth: true,
                  },
                },
                {
                  path: 'work-orders/:id',
                  name: 'WorkOrderDetail',
                  component: WorkOrderDetail,
                  meta: {
                    pageTitle: 'Work Order Details',
                    requiresAuth: true,
                  },
                },
                {
                  path: 'work-orders/:id/edit',
                  name: 'WorkOrderEdit',
                  component: WorkOrderForm,
                  props: _route => ({ isEditMode: true }),
                  meta: {
                    pageTitle: 'Edit Work Order',
                    requiresAuth: true,
                  },
                },
                {
                  path: 'invoices/report',
                  name: 'InvoiceReport',
                  component: InvoiceReport,
                  meta: {
                    pageTitle: 'Invoice Report',
                    requiresAuth: true,
                    requiredPermissions: ['invoices:read']
                  },
                },
                // Inventory Management Routes
                {
                  path: 'inventory',
                  name: 'InventoryDashboard',
                  component: InventoryDashboard,
                  meta: {
                    pageTitle: 'Inventory Management',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ]
                  }
                },
                {
                  path: 'inventory/categories',
                  name: 'InventoryCategories',
                  component: InventoryCategories,
                  meta: {
                    pageTitle: 'Inventory Categories',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ]
                  }
                },
                {
                  path: 'inventory/suppliers',
                  name: 'InventorySuppliers',
                  component: InventorySuppliers,
                  meta: {
                    pageTitle: 'Inventory Suppliers',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ]
                  }
                },
                {
                  path: 'inventory/items',
                  name: 'InventoryItems',
                  component: InventoryItems,
                  meta: {
                    pageTitle: 'Inventory Items',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ]
                  }
                },
                {
                  path: 'inventory/transactions',
                  name: 'InventoryTransactions',
                  component: () => import("@/views/inventory/Transactions.vue"),
                  meta: {
                    pageTitle: 'Inventory Transactions',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ]
                  }
                },
                {
                  path: 'inventory/transactions/:id',
                  name: 'InventoryTransactionDetail',
                  component: () => import("@/views/inventory/TransactionDetail.vue"),
                  props: true,
                  meta: {
                    pageTitle: 'Transaction Details',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ]
                  }
                },
                {
                  path: 'inventory/transfers',
                  name: 'InventoryTransfers',
                  component: TransferInventory,
                  meta: {
                    pageTitle: 'Inventory Transfers',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ]
                  }
                },
                {
                  path: 'inventory/all-transfers',
                  name: 'AllTransfers',
                  component: AllTransfers,
                  meta: {
                    pageTitle: 'All Inventory Transfers',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ]
                  }
                },
                {
                  path: 'inventory/reports',
                  name: 'InventoryReports',
                  component: InventoryReport,
                  meta: {
                    pageTitle: 'Inventory Reports',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ]
                  }
                },
                {
                  path: 'waybills/:id',
                  name: 'WaybillDetail',
                  component: WaybillDetail,
                  meta: { requiresAuth: true }
                },
                // Field Operations Routes
                {
                  path: 'field-inventory',
                  name: 'FieldInventory',
                  component: () => import('../views/field-operations/FieldInventory.vue'),
                  meta: { 
                    pageTitle: 'Field Inventory',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ]
                  }
                },
                {
                  path: 'field-inventory/analytics',
                  name: 'FieldInventoryAnalytics',
                  component: () => import('../views/field-operations/FieldInventoryAnalytics.vue'),
                  meta: {
                    pageTitle: 'Field Inventory Analytics',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ]
                  }
                },
                {
                  path: 'field-inventory/audit',
                  name: 'FieldInventoryAudit',
                  component: () => import('../views/field-operations/FieldInventoryAudit.vue'),
                  meta: { 
                    pageTitle: 'Field Inventory Audit',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.INVENTORY_READ, PERMISSIONS.ADMIN_ACCESS]
                  }
                },
                {
                  path: 'field-work-orders',
                  name: 'FieldWorkOrders',
                  component: () => import('../views/field-operations/FieldWorkOrders.vue'),
                  meta: { 
                    pageTitle: 'Field Work Orders',
                    requiresAuth: true
                  }
                },
                {
                  path: 'field-work-orders/dashboard',
                  name: 'FieldWorkOrdersDashboard',
                  component: () => import('../views/field-operations/FieldWorkOrdersDashboard.vue'),
                  meta: { 
                    pageTitle: 'Work Orders Dashboard',
                    requiresAuth: true
                  }
                },
                {
                  path: 'field-work-orders/technician-performance',
                  name: 'TechnicianPerformance',
                  component: () => import('../views/field-operations/TechnicianPerformance.vue'),
                  meta: { 
                    pageTitle: 'Technician Performance',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.REPORTS_VIEW]
                  }
                },
                {
                  path: 'fuel-tracking',
                  name: 'FuelTracking',
                  component: () => import('../views/field-operations/FuelTracking.vue'),
                  meta: { 
                    pageTitle: 'Fuel Tracking',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.FUEL_READ]
                  }
                },
                {
                  path: 'fuel-tracking/dashboard',
                  name: 'FuelTrackingDashboard',
                  component: () => import('../views/field-operations/FuelTrackingDashboard.vue'),
                  meta: { 
                    pageTitle: 'Fuel Tracking Dashboard',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.FUEL_READ]
                  }
                },
                {
                  path: 'fuel-tracking/analytics',
                  name: 'FuelTrackingAnalytics',
                  component: () => import('../views/field-operations/FuelTrackingAnalytics.vue'),
                  meta: { 
                    pageTitle: 'Fuel Analytics',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.FUEL_READ, PERMISSIONS.REPORTS_VIEW]
                  }
                },
                {
                  path: 'fuel-tracking/environmental',
                  name: 'FuelEnvironmental',
                  component: () => import('../views/field-operations/FuelEnvironmental.vue'),
                  meta: { 
                    pageTitle: 'Environmental Impact',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.FUEL_READ, PERMISSIONS.REPORTS_VIEW]
                  }
                },
                {
                  path: 'gps-tracking',
                  name: 'GPSTracking',
                  component: () => import('../views/field-operations/GPSTracking.vue'),
                  meta: { 
                    pageTitle: 'GPS Tracking',
                    requiresAuth: true
                  }
                },
                {
                  path: 'gps-tracking/analytics',
                  name: 'GPSAnalytics',
                  component: () => import('../views/field-operations/GPSAnalytics.vue'),
                  meta: { 
                    pageTitle: 'GPS Analytics',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.REPORTS_VIEW]
                  }
                },
                {
                  path: 'gps-tracking/reports',
                  name: 'GPSReports',
                  component: () => import('../views/field-operations/GPSReports.vue'),
                  meta: { 
                    pageTitle: 'GPS Reports',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.REPORTS_VIEW]
                  }
                },
                {
                  path: 'unit-checks',
                  name: 'UnitChecks',
                  component: () => import('../views/field-operations/UnitChecks.vue'),
                  meta: { 
                    pageTitle: 'Unit Checks',
                    requiresAuth: true
                  }
                },
                {
                  path: 'unit-checks/metrics',
                  name: 'UnitChecksMetrics',
                  component: () => import('../views/field-operations/UnitChecksMetrics.vue'),
                  meta: { 
                    pageTitle: 'Unit Check Metrics',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.REPORTS_VIEW]
                  }
                },
                {
                  path: 'maintenance-calendar',
                  name: 'MaintenanceCalendar',
                  component: () => import('../views/field-operations/MaintenanceCalendar.vue'),
                  meta: { 
                    pageTitle: 'Maintenance Calendar',
                    requiresAuth: true
                  }
                },
                {
                  path: 'time-tracking/reports',
                  name: 'TimeTrackingReports',
                  component: () => import('../views/field-operations/TimeTrackingReports.vue'),
                  meta: { 
                    pageTitle: 'Time Tracking Reports',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.TIME_READ, PERMISSIONS.REPORTS_VIEW]
                  }
                },
                {
                  path: 'powerpacks/fleet-overview',
                  name: 'PowerpackFleetOverview',
                  component: () => import('../views/field-operations/PowerpackFleetOverview.vue'),
                  meta: { 
                    pageTitle: 'Powerpack Fleet Overview',
                    requiresAuth: true
                  }
                },
                {
                  path: 'powerpacks/predictive-maintenance',
                  name: 'PowerpackPredictiveMaintenance',
                  component: () => import('../views/field-operations/PowerpackPredictiveMaintenance.vue'),
                  meta: { 
                    pageTitle: 'Predictive Maintenance',
                    requiresAuth: true
                  }
                },
                {
                  path: 'powerpacks/roi-analysis',
                  name: 'PowerpackROIAnalysis',
                  component: () => import('../views/field-operations/PowerpackROIAnalysis.vue'),
                  meta: { 
                    pageTitle: 'Powerpack ROI Analysis',
                    requiresAuth: true,
                    requiredPermissions: [PERMISSIONS.REPORTS_VIEW]
                  }
                },
                // More authenticated routes can be nested here
            ]
        },
        {
            // The login page is outside the MainLayout
            name: 'login',
            path: '/login',
            component: loginPage,
            meta: {requiresUnauthenticated: true}
        },
        {path: '/dashboard', name: 'Dashboard', component: Dashboard},
        {path: '/activity', name: 'ActivityFeed', component: ActivityFeedView},

        {
            // Debug CORS page - accessible without auth for troubleshooting
            name: 'debug-cors',
            path: '/debug-cors',
            component: () => import('../views/DebugCORS.vue'),
            meta: {requiresUnauthenticated: true}
        },
        {
            // Test EditableLocation component
            name: 'test-location',
            path: '/test-location',
            component: () => import('../components/requests/EditableLocationTest.vue'),
            meta: {requiresUnauthenticated: true}
        },
        {
            // Test EditableTrack component
            name: 'test-track',
            path: '/test-track',
            component: () => import('../components/requests/EditableTrackTest.vue'),
            meta: {requiresUnauthenticated: true}
        },
        {path: '/trains/:trainid/fieldui', component: FieldTrainCheck, props: true, meta: {requiresAuth: true}},
        {path: '/tests/unit-card', component: FieldUnitCardTestHarness, name: 'FieldUnitCardTests'},
        {path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundPage},
    ]
})

router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore();

    // Check auth status, but with rate limiting
    // Only force a fresh check when navigating to an auth-required page from an external source
    const forceCheck = to.meta.requiresAuth === true && (from.name === null || from.path === '/login');
    await authStore.checkAuthStatus(forceCheck);

    if (to.meta.requiresAuth === true) {
        if (authStore.user) {
            // Check permission-based access
            const requiredPermissions = to.meta.requiredPermissions;
            if (requiredPermissions && requiredPermissions.length > 0) {
                const permissions = Array.isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions];
                if (!authStore.hasAnyPermission(permissions)) {
                    // Store the required permission in route params for the error page
                    next({
                        path: '/forbidden',
                        query: { 
                            required: permissions[0],
                            from: to.fullPath
                        }
                    });
                    return;
                }
            }
            next();
        } else {
            next('/login');
        }
    } else if (to.meta.requiresUnauthenticated === true && authStore.isAuthenticated) {
        next('/');
    } else {
        next();
    }
});


export default router
